import { NotificationSettings } from '@trimble/types';
import { NotificationSettings as TcpsNotificationSettings } from '../../generated/index';
import { mapToTcpsModel as mapDetailsTo } from './settings-details-mapper';
import { mapToDomain as mapToSettings } from './settings-details-mapper';

export const mapToTcpsModel = (
  input: NotificationSettings
): TcpsNotificationSettings | null => {
  return {
    projectId: input.projectId,
    notificationSettings: {
      files: input.notificationSettings.files.map((value) =>
        mapDetailsTo(value)
      ),
      folders: input.notificationSettings.folders.map((value) =>
        mapDetailsTo(value)
      ),
      comments: input.notificationSettings.comments.map((value) =>
        mapDetailsTo(value)
      ),
      users: input.notificationSettings.users.map((value) =>
        mapDetailsTo(value)
      ),
      views: input.notificationSettings.views.map((value) =>
        mapDetailsTo(value)
      ),
      clashsets: input.notificationSettings.clashsets.map((value) =>
        mapDetailsTo(value)
      ),
      releases: input.notificationSettings.releases.map((value) =>
        mapDetailsTo(value)
      ),
      todo: input.notificationSettings.todo.map((value) => mapDetailsTo(value)),
      other: input.notificationSettings.other.map((value) =>
        mapDetailsTo(value)
      ),
    },
    allowUserSettings: input.allowUserSettings,
    dailyDigestTimeZone: input.dailyDigestTimeZone,
  };
};

export const mapToDomain = (
  input: TcpsNotificationSettings
): NotificationSettings => ({
  projectId: input.projectId,
  notificationSettings: {
    files:
      input.notificationSettings.files?.map((value) => mapToSettings(value)) ??
      [],
    folders:
      input.notificationSettings.folders?.map((value) =>
        mapToSettings(value)
      ) ?? [],
    comments:
      input.notificationSettings.comments?.map((value) =>
        mapToSettings(value)
      ) ?? [],
    users:
      input.notificationSettings.users?.map((value) => mapToSettings(value)) ??
      [],
    views:
      input.notificationSettings.views?.map((value) => mapToSettings(value)) ??
      [],
    clashsets:
      input.notificationSettings.clashsets?.map((value) =>
        mapToSettings(value)
      ) ?? [],
    releases:
      input.notificationSettings.releases?.map((value) =>
        mapToSettings(value)
      ) ?? [],
    todo:
      input.notificationSettings.todo?.map((value) => mapToSettings(value)) ??
      [],
    other:
      input.notificationSettings.other?.map((value) => mapToSettings(value)) ??
      [],
    topics: [],
  },
  allowUserSettings: input.allowUserSettings,
  dailyDigestTimeZone: input.dailyDigestTimeZone,
});
